<form #paymentForm="ngForm" id="paymentForm" class="px-4 mt-5" validate>
  <div class="row px-1">
    <div class="col-8">
      <div>
<!-- Primera fila -->
        <h5> <b> <i translate> MemoPayments.Type Content </i> </b> </h5>
        <hr class="mb-5">

        <div class="p-fluid grid my-3 mt-4">
          <!-- Frecuencia -->
          @if(isNewPayment){
            <div class="p-field col-3 pr-4">
              <p-floatlabel>
                <p-select
                  name="frequencyCombo"
                  #frequencyCombo="ngModel"
                  appendTo="body"
                  optionLabel="keyTranslated"
                  optionValue="keyValue"
                  [options]="frequencyList"
                  [(ngModel)]="payment.frequency"
                  [disabled]="paymentSavedOk"
                  [ngClass]="{'invalid-colors': frequencyTouched && !payment.frequency }"
                  [showClear]="true"
                  (onChange)="frequencyChoice($event)"
                  required
                />
                <label class="required" for="frequencyCombo" translate> Common.Frequency </label>
              </p-floatlabel>
              <small *ngIf="frequencyTouched && !payment.frequency" class="text-danger" translate> Common.Required Frequency Choice </small>
            </div>
          } @else {
            <!-- Frecuencia deshabilitada -->
            <div class="p-field col-3 pr-4">
              <p-floatlabel>
                <input pInputText
                       name="frequency"
                       type="text"
                       [disabled]="true"
                       [(ngModel)]="frequency"/>
                <label class="required" for="frequency" translate> Common.Frequency </label>
              </p-floatlabel>
            </div>
          }
          <!-- Source memo content -->
          @if(isNewPayment){
            <div class="p-field col-3 col-sm-3-5 col-md-3-5 col-lg-3-5 col-xl-3-5 col-xxl-3-5 pr-4">
              <p-floatlabel>
                <p-select
                  name="memoContentOriginCombo"
                  #memoContentOriginCombo="ngModel"
                  appendTo="body"
                  optionLabel="messageKeyTranslated"
                  [options]="originContent"
                  [(ngModel)]="payment.memoContentOrigin"
                  [disabled]="!payment.frequency || isLoadingOriginContent || paymentSavedOk"
                  [ngClass]="{'invalid-colors': memoContentOriginTouched && payment.frequency && !payment.memoContentOrigin }"
                  [showClear]="true"
                  (onBlur)="memoContentOriginTouched = true"
                  (onChange)="memoContentOriginChoice()"
                  required
                />
                <label class="required" for="memoContentOriginCombo" translate> MemoPayments.Content Origin </label>
              </p-floatlabel>

              <small *ngIf="memoContentOriginTouched && payment.frequency && !payment.memoContentOrigin" class="text-danger" translate> MemoPayments.Required Memo Content Origin Choice </small>
            </div>
          } @else {
            <div class="p-field col-3 pr-4">
              <p-floatlabel>
                <input pInputText
                       name="memoContentOrigin"
                       type="text"
                       [disabled]="true"
                       [(ngModel)]="payment.memoContentOrigin.memoContentOriginCode"/>
                <label class="required" for="memoContentOrigin" translate> MemoPayments.Content Origin </label>
              </p-floatlabel>
            </div>
          }
          <!-- Origen contenido memo (deshabilitado) -->
          <!-- Tipo de contenido -->
          <div class="p-field col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 pr-4">
            @if(isNewPayment){
              <p-floatlabel>
                <p-select
                  name="docType"
                  #docType="ngModel"
                  appendTo="body"
                  optionLabel="fileCode"
                  [options]="docTypesList"
                  [(ngModel)]="payment.docType"
                  [disabled]="!payment.memoContentOrigin || paymentSavedOk || isSinglePayment "
                  [showClear]="true"
                  (onBlur)="docTypeTouched = true"
                  required
                />
                <label class="required" for="docType" translate> MemoPayments.Content Type </label>
              </p-floatlabel>

              <small *ngIf="docTypeTouched && docType.errors?.required" class="text-danger" translate> MemoPayments.Required
                Content Type </small>
              <small *ngIf="docTypeError.description" class="text-danger" translate> {{ docTypeError.description }} </small>
            }
            <!-- Tipo de contenido (deshabilitado) -->
            <div *ngIf="!isNewPayment || isTaskDetail">
              <p-floatlabel>
                <input pInputText
                       maxlength="50"
                       name="docType"
                       type="text"
                       [disabled]="true"
                       [(ngModel)]="payment.docType.fileCode"/>
                <label class="required" for="docType" translate> Common.Document Type </label>
              </p-floatlabel>
            </div>
          </div>
          <!-- Tipo de pago -->
          <div class="p-field col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 pr-4">
            <div *ngIf="isNewPayment">
              <p-floatlabel>
                <p-select
                  name="paymentType"
                  #paymentType="ngModel"
                  appendTo="body"
                  optionLabel="keyTranslated"
                  optionValue="keyValue"
                  [options]="paymentTypesList"
                  [(ngModel)]="payment.paymentType"
                  [disabled]="!payment.frequency || !payment.memoContentOrigin || paymentSavedOk || isArc"
                  [showClear]="true"
                  (onBlur)="paymentTypeTouched = true"
                  required
                />
                <label class="required" for="paymentType" translate> MemoPayments.Payment Type </label>
              </p-floatlabel>

              <small *ngIf="paymentTypeTouched && paymentType.errors?.required" class="text-danger" translate> MemoPayments.Required PaymentType </small>
              <small *ngIf="paymentTypeError.description && !paymentTypeError.quantityMax" class="text-danger" translate> {{ paymentTypeError.description }} </small>
              <small *ngIf="paymentTypeError.description && paymentTypeError.quantityMax" class="text-danger" translate> {{
                  paymentTypeError.description | translate:{
                    quantityMax: paymentTypeError.quantityMax,
                    quantityMin: paymentTypeError.quantityMin
                  }
                }}
              </small>
            </div>
            <!-- Tipo de pago (deshabilitado) -->
            <div *ngIf="!isNewPayment || isTaskEditable">
              <p-floatlabel>
                <input pInputText
                       name="paymentType"
                       type="text"
                       [disabled]="true"
                       [(ngModel)]="payment.paymentType"/>
                <label class="required" for="paymentType" translate> MemoPayments.Payment Type</label>
              </p-floatlabel>
            </div>
          </div>
        </div>
        <div>
          <span>* <b translate> MemoPayments.Warning Change Frequency </b></span>
        </div>
      </div>

<!-- Segunda fila -->
      <h5 class="mt-4"> <b> <i translate> MemoPayments.Customer Details </i> </b> </h5>
      <hr class="mb-5">

      <div class="p-fluid grid my-3 mt-3">
        <!-- Cliente -->
        <div class="pr-4 p-field p-field-load col" [ngClass]="{ 'col-xl-6 col-xxl-6': isNewPayment, 'col-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 pr-4': !isNewPayment }">
          <div *ngIf="isNewPayment">
            <p-floatlabel>
              <p-select
                name="customers"
                #customers="ngModel"
                appendTo="body"
                optionLabel="name"
                [loading]="isLoadingCustomer"
                [filter]="true"
                [options]="customerList"
                [(ngModel)]="payment.customer"
                [disabled]="!payment.frequency || !payment.memoContentOrigin || isLoadingCustomer || paymentSavedOk"
                [readonly]="!isNewPayment || isTaskEditable"
                [showClear]="true"
                (onChange)="customerSelection()"
                (onBlur)="customerTouched = true"
                required
              />
              <label class="required" for="customers" translate> Common.Customer </label>
            </p-floatlabel>

            <small *ngIf="customerTouched && customers.errors?.required  && customerList.length > 0" class="text-danger" translate> Generic Errors.Required Customer </small>
            <small *ngIf="NameError.description" class="text-danger" translate>
              {{
                NameError.description | translate:{
                  quantityMax: NameError.quantityMax,
                  quantityMin: NameError.quantityMin
                }
              }}
            </small>
          </div>
          <!-- Cliente (deshabilitado) -->
          <div *ngIf="!isNewPayment || isTaskEditable">
            <p-floatlabel>
              <input pInputText
                     maxlength="50"
                     name="customers"
                     type="text"
                     [disabled]="true"
                     [(ngModel)]="payment.customer.shortName"/>
              <label class="required" for="customers" translate> Common.Customer </label>
            </p-floatlabel>
          </div>

        </div>
        <!-- Aerolínea -->
        <div class="pr-4 p-field col-6 col-md-4 col-lg-3" [ngClass]="{ 'col-xl-1-5 col-xxl-1-5': isNewPayment, 'col-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 pr-2': !isNewPayment }">
          <div *ngIf="isNewPayment">
            <p-floatlabel>
              <p-select
                name="airlines"
                #airlines="ngModel"
                appendTo="body"
                optionLabel="airlineCode"
                optionValue="airlineCode"
                [filter]="true"
                [options]="airlineList"
                [(ngModel)]="payment.airline"
                [disabled]="!payment.customer || !payment.frequency || !payment.memoContentOrigin || paymentSavedOk"
                [showClear]="true"
                (onBlur)="airlineTouched = true"
                (onChange)="airlineCountrySelection('airlineSelectionMethod')"
                required
              />
              <label class="required" for="airlines" translate> Common.Airline </label>
            </p-floatlabel>

            <small *ngIf="airlineTouched && airlines.errors?.required" class="text-danger" translate>Required
              Airline</small>
            <small *ngIf="airlineError.description" class="text-danger" translate> {{
                airlineError.description | translate:{
                  quantityMax: airlineError.quantityMax,
                  quantityMin: airlineError.quantityMin
                }
              }}
            </small>
          </div>
          <!-- Aerolínea (deshabilitado) -->
          <div *ngIf="!isNewPayment || isTaskEditable">
            <p-floatlabel>
              <input pInputText
                     maxlength="50"
                     name="airlines"
                     type="text"
                     [disabled]="true"
                     [(ngModel)]="payment.airline"/>
              <label class="required" for="airlines" translate>Airline</label>
            </p-floatlabel>
          </div>
        </div>
        <!-- País -->
        <div class="pr-4 p-field col-6 col-md-4 col-lg-3" [ngClass]="{ 'col-xl-1-5 col-xxl-1-5': isNewPayment, 'col-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 pr-4': !isNewPayment }">
          <div *ngIf="isNewPayment">
            <p-floatlabel>
              <p-select
                name="countries"
                #countries="ngModel"
                appendTo="body"
                optionLabel="countryCode"
                optionValue="countryCode"
                [filter]="true"
                [options]="countryList"
                [(ngModel)]="payment.bsp"
                [disabled]="!payment.frequency || !payment.memoContentOrigin || isArc || !payment.airline || paymentSavedOk"
                [showClear]="true"
                (onBlur)="countryTouched = true"
                (onChange)="airlineCountrySelection('countrySelectionMethod')"
                required
              />
              <label class="required" for="countries" translate> Common.Country </label>
            </p-floatlabel>

            <small *ngIf="countryTouched && countries.errors?.required"  class="text-danger" translate> Generic Errors.Required Country </small>
            <small *ngIf="bspError.description && !bspError.quantityMax" class="text-danger" translate> {{ bspError.description }} </small>
            <small *ngIf="bspError.description && bspError.quantityMax"  class="text-danger" translate> {{
                bspError.description | translate:{
                  quantityMax: bspError.quantityMax,
                  quantityMin: bspError.quantityMin
                }
              }}
            </small>
          </div>
          <!-- País (deshabilitado) -->
          <div *ngIf="!isNewPayment || isTaskEditable">
            <p-floatlabel>
              <input pInputText
                     maxlength="50"
                     name="countries"
                     type="text"
                     [disabled]="true"
                     [(ngModel)]="payment.bsp"/>
              <label class="required" for="countries" translate> Common.Country </label>
            </p-floatlabel>
          </div>
        </div>
      </div>

<!-- TODO Tercera fila Pendiente refactorizar-->
      <h5 class="mt-4"> <b> <i translate> MemoPayments.Ranges </i> </b> </h5>
      <hr class="mb-5">

      <div class="p-fluid grid mt-3">
        <div *ngIf="isAcmAdmEnabled" class="p-field col-3 col-md-3 col-lg-2 col-xl-1-5 pr-4">
          <!-- Documento inicial ACM -->
          <div *ngIf="payment.docType != undefined && payment.docType.fileCode.includes('ACM')">
            <p-floatlabel>
              <input pInputText
                     #fromDocAcm="ngModel"
                     name="fromDoc"
                     maxlength="10"
                     minlength="10"
                     type="text"
                     [(ngModel)]="payment.fromDocument"
                     [disabled]="payment.docType == undefined || payment.docType.fileCode == 'ADM' || (isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                     [ngClass]="{ 'invalid-colors': fromDocAcmTouched && (fromDocAcm.errors || fromDocumentError.description || fromDocAcm?.valid && payment.toDocument < payment.fromDocument) }"
                     [pattern]="patternDoc.numeric"
                     (blur)="fromDocAcmTouched = true"
                     required>
              <label class="required" for="fromDocAcm" translate> MemoPayments.From Document ACM </label>
            </p-floatlabel>

            <small *ngIf="fromDocAcmTouched && fromDocAcm.errors?.required" class="text-danger" translate> MemoPayments.Required From Document </small>
            <small *ngIf="fromDocAcmTouched && fromDocAcm.errors?.pattern" class="text-danger" translate> Incorrect Numeric Format </small>
            <small *ngIf="fromDocAcmTouched && fromDocAcm.errors?.minlength && !fromDocAcm.errors?.pattern" class="text-danger" translate> {{ 'Length Required Document' | translate: {quantityMin: 10} }} </small>
            <small *ngIf="fromDocumentError.description" class="text-danger" translate> {{
                fromDocumentError.description | translate:{
                  quantityMax: fromDocumentError.quantityMax,
                  quantityMin: fromDocumentError.quantityMin
                }
              }}
            </small>
          </div>

          <!-- Documento inicial ACM deshablitado-->
          <div *ngIf="payment.docType == undefined || !payment.docType.fileCode.includes('ACM')">
            <p-floatlabel>
              <input pInputText
                     name="fromDoc"
                     type="text"
                     [disabled]=true>
              <label class="required" for="fromDocAcm" translate> MemoPayments.From Document ACM </label>
            </p-floatlabel>
          </div>
        </div>
        <div class="p-field col-3 col-md-3 col-lg-2 col-xl-1-5 pr-4">
          <!-- Documento inicial ADM -->
          <div *ngIf="payment.docType != undefined && payment.docType.fileCode.includes('ADM')">
            <p-floatlabel>
              <input pInputText
                     #fromDocAdm="ngModel"
                     name="fromDocAdm"
                     maxlength="10"
                     minlength="10"
                     type="text"
                     [(ngModel)]="payment.fromDocumentAdm"
                     [disabled]="(isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                     [ngClass]="{ 'invalid-colors': fromDocAdmTouched && (fromDocAdm.errors || fromDocumentError.description || fromDocAdm?.valid && payment.toDocumentAdm < payment.fromDocumentAdm) }"
                     [pattern]="patternDoc.numeric"
                     (blur)="fromDocAdmTouched = true"
                     required>
              <label class="required" for="fromDocAdm" translate> MemoPayments.From Document ADM </label>
            </p-floatlabel>

            <small *ngIf="fromDocAdmTouched && fromDocAdm.errors?.required" class="text-danger" translate>
              MemoPayments.Required From Document </small>
            <small *ngIf="fromDocAdmTouched && fromDocAdm.errors?.pattern" class="text-danger" translate> Incorrect Numeric Format </small>
            <small *ngIf="fromDocAdmTouched && fromDocAdm.errors?.minlength && !fromDocAdm.errors?.pattern" class="text-danger" translate> {{ 'Length Required Document' | translate: {quantityMin: 10} }} </small>
            <small *ngIf="fromDocumentError.description" class="text-danger" translate> {{
                fromDocumentError.description | translate:{
                  quantityMax: fromDocumentError.quantityMax,
                  quantityMin: fromDocumentError.quantityMin
                }
              }}
            </small>
          </div>

          <!-- Documento inicial ADM deshabilitado-->
          <div *ngIf="payment.docType == undefined || !payment.docType.fileCode.includes('ADM')">
          <p-floatlabel>
            <input pInputText
                   name="fromDocAdm"
                   type="text"
                   [disabled]=true>
            <label class="required" for="fromDocAdm" translate> MemoPayments.From Document ADM </label>
          </p-floatlabel>
          </div>
        </div>
        <div *ngIf="isAcmAdmEnabled" class="p-field col-3 col-md-3 col-lg-2 col-xl-1-5 pr-4">
          <!-- Documento final ACM -->
          <div *ngIf="payment.docType != undefined && payment.docType.fileCode.includes('ACM')">
            <p-floatlabel>
              <input pInputText
                     #toDocAcm="ngModel"
                     type="text"
                     name="toDocAcm"
                     maxlength="10"
                     minlength="10"
                     [(ngModel)]="payment.toDocument"
                     [disabled]="(isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                     [ngClass]="{ 'invalid-colors': toDocAcmTouched && (toDocAcm.errors || toDocumentError.description || fromDocAcm?.valid && payment.toDocument < payment.fromDocument) }"
                     [pattern]="patternDoc.numeric"
                     (blur)="toDocAcmTouched = true"
                     required>
              <label class="required" for="toDocAcm" translate> MemoPayments.To Document ACM </label>
            </p-floatlabel>

            <small *ngIf="toDocAcmTouched && toDocAcm.errors?.required" class="text-danger" translate> MemoPayments.Required To Document </small>
            <small *ngIf="toDocAcmTouched && toDocAcm.errors?.pattern" class="text-danger" translate> Incorrect Numeric Format </small>
            <small *ngIf="toDocAcmTouched && toDocAcm.errors?.minlength && !toDocAcm.errors?.pattern" class="text-danger" translate> {{ 'Length Required Document' | translate: {quantityMin: 10} }} </small>
            <small *ngIf="!toDocAcm.errors?.pattern && (payment.toDocument < payment.fromDocument)" class="text-danger" translate> MemoPayments.Incorrect To Document</small>
            <small *ngIf="toDocumentError.description" class="text-danger" translate> {{
                toDocumentError.description | translate:{
                  quantityMax: toDocumentError.quantityMax,
                  quantityMin: toDocumentError.quantityMin
                }
              }}
            </small>
          </div>

          <!-- Documento final ACM deshabilitado-->
          <div *ngIf="payment.docType == undefined || !payment.docType.fileCode.includes('ACM')">
            <p-floatlabel>
              <input pInputText
                     type="text"
                     name="toDocAcm"
                     [disabled]="true">
              <label class="required" for="toDocAcm" translate> MemoPayments.To Document ACM </label>
            </p-floatlabel>
          </div>
        </div>
        <div class="p-field col-3 col-md-3 col-lg-2 col-xl-1-5 pr-4">

          <!-- Documento final ADM -->
          <div *ngIf="payment.docType != undefined && payment.docType.fileCode.includes('ADM')">
          <p-floatlabel>
            <input pInputText
                   #toDocAdm="ngModel"
                   type="text"
                   name="toDocAdm"
                   maxlength="10"
                   minlength="10"
                   [(ngModel)]="payment.toDocumentAdm"
                   [disabled]="(isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                   [ngClass]="{ 'invalid-colors': toDocAdmTouched && (toDocAdm.errors || toDocumentError.description || fromDocAdm?.valid && payment.toDocumentAdm < payment.fromDocumentAdm) }"
                   [pattern]="patternDoc.numeric"
                   (blur)="toDocAdmTouched = true"
                   required>
            <label class="required" for="toDocAdm" translate> MemoPayments.To Document ADM </label>
          </p-floatlabel>

          <small *ngIf="toDocAdmTouched && toDocAdm.errors?.required" class="text-danger" translate> MemoPayments.Required To Document </small>
          <small *ngIf="toDocAdmTouched && toDocAdm.errors?.pattern" class="text-danger" translate> Incorrect Numeric Format </small>
          <small *ngIf="toDocAdmTouched && toDocAdm.errors?.minlength && !toDocAdm.errors?.pattern" class="text-danger" translate> {{ 'Length Required Document' | translate: {quantityMin: 10} }} </small>
          <small *ngIf="!toDocAdm.errors?.pattern && (payment.toDocumentAdm < payment.fromDocumentAdm)" class="text-danger" translate> MemoPayments.Incorrect To Document</small>
          <small *ngIf="toDocumentError.description" class="text-danger" translate> {{
              toDocumentError.description | translate:{
                quantityMax: toDocumentError.quantityMax,
                quantityMin: toDocumentError.quantityMin
              }
            }}
          </small>
          </div>

          <!-- Documento final ADM deshabilitado-->
          <div *ngIf="payment.docType == undefined || !payment.docType.fileCode.includes('ADM')">
          <p-floatlabel>
            <input pInputText
                   type="text"
                   name="toDocAdm"
                   [disabled]="true">
            <label class="required" for="toDocAdm" translate> MemoPayments.To Document ADM </label>
          </p-floatlabel>
          </div>
        </div>

        <!-- Máximo relacionado -->
        <div class="p-field col-3 col-md-3 col-lg-2 col-xl-1-5 pr-4">
          <div>
            <p-floatlabel>
              <input pInputText
                     #maxRelated="ngModel"
                     name="maxRelated"
                     type="text"
                     [(ngModel)]="payment.maxRelated"
                     [pattern]="pattern.numeric"
                     [disabled]="(isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                     [ngClass]="{ 'invalid-colors': maxRelatedTouched && (maxRelated.errors?.required || maxRelated.errors?.pattern || isMaxRelatedZero || isMaxRelatedHigherMax || maxRelatedError.description) }"
                     (blur)="maxRelatedTouched = true"
                     (ngModelChange)="maxRelatedSelection()"
                     required>
              <label class="required" for="maxRelated" translate> MemoPayments.Max Related</label>
            </p-floatlabel>

            <small *ngIf="maxRelatedTouched && maxRelated.errors?.required" class="text-danger" translate> MemoPayments.MemoPayments.Required MaxRelated </small>
            <small *ngIf="maxRelatedTouched && (maxRelated.errors?.pattern || isMaxRelatedZero)" class="text-danger" translate> MemoPayments.Incorrect Numeric Higher0 Format</small>
            <small *ngIf="maxRelatedTouched && isMaxRelatedHigherMax" class="text-danger" translate> {{
                'Max Value MaxRelated With Detail' | translate: {
                  default: defaultMaxRelated,
                  diffCountry: diffCountry,
                  diffValue: diffValueMaxRelated
                }
              }}
            </small>
            <small *ngIf="maxRelatedError.description" class="text-danger" translate> {{
                maxRelatedError.description | translate:{
                  quantityMax: maxRelatedError.quantityMax,
                  quantityMin: maxRelatedError.quantityMin
                }
              }} </small>
          </div>
        </div>
        <!-- Secuencia -->
        <div class="p-field col-3 col-md-3 col-lg-2 col-xl-1-5 pr-4">
          <div>
            <p-floatlabel>
              <input pInputText
                     #fileSequence="ngModel"
                     name="fileSequence"
                     maxlength="3"
                     type="text"
                     [(ngModel)]="payment.fileSequence"
                     [disabled]="(!payment.frequency || !payment.memoContentOrigin || payment.frequency == periodicStr || payment.frequency == periodRangeStr || !payment.bsp || !payment.airline || paymentSavedOk) || !isNewPayment || isTaskEditable"
                     [ngClass]="{ 'invalid-colors': fileSequenceTouched && (fileSequence.errors?.required || errorFileSequenceRange || fileSequenceError.description || fileSequence.errors?.pattern) }"
                     [pattern]="pattern.numeric"
                     [readonly]="!isNewPayment || checkMemoPaymentFileSequence()"
                     (ngModelChange)="fileSequenceSelection()"
                     [required]="isSinglePayment">
              <label [ngClass]="{'required': isSinglePayment }" for="fileSequence" translate> MemoPayments.Sequence </label>
            </p-floatlabel>

            <small *ngIf="fileSequenceTouched && fileSequence.errors?.required" class="text-danger" translate> MemoPayments.Required Sequence</small>
            <small *ngIf="fileSequenceTouched && fileSequence.errors?.pattern" class="text-danger" translate> Incorrect Numeric Format </small>
            <small *ngIf="fileSequenceTouched && errorFileSequenceRange" class="text-danger" translate> {{
                'Max & Minimum Value File Sequence' | translate: {
                  minFileSequence: minFileSequence,
                  maxFileSequence: maxFileSequence
                }
              }}
            </small>
            <small *ngIf="fileSequenceError.description" class="text-danger" translate> {{
                fileSequenceError.description | translate:{
                  quantityMax: fileSequenceError.quantityMax,
                  quantityMin: fileSequenceError.quantityMin
                }
              }}
            </small>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <!-- Documento inicial -->
        @if(!isAcmAdmEnabled){
          <div class="p-field col-6 col-md-4 col-lg-3 col-xl-1-5 pr-4">
            <p-floatlabel>
              <input pInputText
                     #fromDoc="ngModel"
                     name="fromDoc"
                     maxlength="10"
                     minlength="10"
                     type="text"
                     [(ngModel)]="payment.fromDocument"
                     [disabled]="(isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                     [ngClass]="{ 'invalid-colors': fromDocTouched && (fromDoc.errors || fromDocumentError.description || fromDoc?.valid && payment.toDocument < payment.fromDocument) }"
                     [pattern]="pattern.numeric"
                     (blur)="fromDocTouched = true"
                     required>
              <label class="required" for="fromDoc" translate> MemoPayments.From Document </label>
            </p-floatlabel>

            <small *ngIf="fromDocTouched && fromDoc.errors?.required" class="text-danger" translate> MemoPayments.Required From Document </small>
            <small *ngIf="fromDocTouched && fromDoc.errors?.pattern && !fromDoc.errors?.minlength" class="text-danger" translate> Incorrect Numeric Format </small>
            <small *ngIf="fromDocTouched && fromDoc.errors?.minlength && !fromDoc.errors?.pattern" class="text-danger" translate> {{ 'Length Required Document' | translate: {quantityMin: 10} }} </small>
            <small *ngIf="fromDocumentError.description" class="text-danger" translate> {{
                fromDocumentError.description | translate:{
                  quantityMax: fromDocumentError.quantityMax,
                  quantityMin: fromDocumentError.quantityMin
                }
              }}
            </small>
          </div>
          <!-- Documento final -->
          <div class="p-field col-6 col-md-4 col-lg-3 col-xl-1-5 pr-4">
            <p-floatlabel>
              <input pInputText
                     #toDoc="ngModel"
                     type="text"
                     name="toDoc"
                     maxlength="10"
                     minlength="10"
                     [(ngModel)]="payment.toDocument"
                     [disabled]="(isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                     [ngClass]="{ 'invalid-colors': toDocTouched && (toDoc.errors || toDocumentError.description || fromDoc?.valid && payment.toDocument < payment.fromDocument) }"
                     [pattern]="pattern.numeric"
                     (blur)="toDocTouched = true"
                     required>
              <label class="required" for="toDoc" translate> MemoPayments.To Document </label>
            </p-floatlabel>

            <small *ngIf="toDocTouched && toDoc.errors?.required" class="text-danger" translate> MemoPayments.Required To Document </small>
            <small *ngIf="toDocTouched && toDoc.errors?.pattern" class="text-danger" translate> Incorrect Numeric Format </small>
            <small *ngIf="toDocTouched && toDoc.errors?.minlength && !toDoc.errors?.pattern" class="text-danger" translate> {{ 'Length Required Document' | translate: {quantityMin: 10} }} </small>
            <small *ngIf="!toDoc.errors?.pattern && (payment.toDocument < payment.fromDocument)" class="text-danger" translate> MemoPayments.Incorrect To Document</small>
            <small *ngIf="toDocumentError.description" class="text-danger" translate> {{
                toDocumentError.description | translate:{
                  quantityMax: toDocumentError.quantityMax,
                  quantityMin: toDocumentError.quantityMin
                }
              }}
            </small>
          </div>
        }

        <!-- Próximo documento -->
        <div *ngIf="isTaskDetail" class="p-field col-6 col-md-4 col-lg-3 col-xl-1-5 pr-4">
          <p-floatlabel>
            <input pInputText
                   name="currentDocument"
                   type="text"
                   [disabled]="true"
                   [(ngModel)]="payment.currentDocument"/>
            <label for="currentDocument" translate> MemoPayments.Next Document</label>
          </p-floatlabel>
        </div>
      </div>

<!-- Cuarta fila -->
      <h5 class="mt-4"> <b> <i translate> MemoPayments.Contact Info </i> </b> </h5>
      <hr class="mb-5">

      <div class="p-fluid grid mt-3">
        <!-- Nombre de contacto -->
        <div class="p-field col-6 col-md-5 col-lg-5 col-xl-5 pr-4">
          <div>
            <p-floatlabel>
              <input pInputText
                     #contactName="ngModel"
                     name="contactName"
                     maxlength="49"
                     type="text"
                     [(ngModel)]="payment.contactName"
                     [disabled]="(isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                     [ngClass]="{ 'invalid-colors': contactNameTouched && (contactName.errors || contactNameError.description) }"
                     [pattern]="pattern.DISH_alphanumeric"
                     (blur)="contactNameTouched = true"
                     required>
              <label class="required" for="contactName" translate>Contact Name</label>
            </p-floatlabel>

            <small *ngIf="contactNameTouched && contactName.errors?.pattern" class="text-danger" translate> Incorrect Alpha Numeric DISH Format </small>
            <small *ngIf="contactNameTouched && contactName.errors?.required" class="text-danger" translate> Required Contact Name </small>
            <small *ngIf="contactNameError.description" class="text-danger" translate> {{
                contactNameError.description | translate:{
                  quantityMax: contactNameError.quantityMax,
                  quantityMin: contactNameError.quantityMin
                }
              }}
            </small>
          </div>
        </div>
        <!-- Correo electrónico de contacto -->
        <div class="p-field col-6 col-md-4 col-lg-4 col-xl-4 pr-4">
          <div>
            <p-floatlabel>
              <input pInputText
                     #email="ngModel"
                     name="email"
                     maxlength="49"
                     type="text"
                     [(ngModel)]="payment.contactEmail"
                     [disabled]="(isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                     [ngClass]="{ 'invalid-colors': emailTouched && (email.errors || contactEmailError.description) }"
                     [pattern]="pattern.uniqueEmail"
                     (blur)="emailTouched = true"
                     required>
              <label class="required" for="contactEmail" translate>Contact Email</label>
            </p-floatlabel>

            <small *ngIf="emailTouched && email.errors?.pattern" class="text-danger" translate> Generic Errors.Incorrect Email Format </small>
            <small *ngIf="emailTouched && email.errors?.required" class="text-danger" translate> Generic Errors.Required Email </small>
            <small *ngIf="contactEmailError.description" class="text-danger" translate> {{
                contactEmailError.description | translate:{
                  quantityMax: contactEmailError.quantityMax,
                  quantityMin: contactEmailError.quantityMin
                }
              }}
            </small>
          </div>
        </div>
        <!-- Teléfono de contacto -->
        <div class="p-field col-6 col-md-3 col-lg-3 col-xl-3 pr-4">
          <div>
            <p-floatlabel>
              <input pInputText
                     #phone="ngModel"
                     name="phone"
                     maxlength="30"
                     type="text"
                     [(ngModel)]="payment.contactPhone"
                     [disabled]="(isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                     [ngClass]="{ 'invalid-colors': phoneTouched && (phone.errors || contactPhoneError.description) }"
                     [pattern]="pattern.phone"
                     (blur)="phoneTouched = true"
                     required>
              <label class="required" for="phone" translate>Contact Phone</label>
            </p-floatlabel>

            <small *ngIf="phoneTouched && phone.errors?.pattern" class="text-danger" translate> Incorrect Phone Format </small>
            <small *ngIf="phoneTouched && phone.errors?.required" class="text-danger" translate> Required Contact Phone </small>
            <small *ngIf="contactPhoneError.description" class="text-danger" translate> {{
                contactPhoneError.description | translate:{
                  quantityMax: contactPhoneError.quantityMax,
                  quantityMin: contactPhoneError.quantityMin
                }
              }}
            </small>
          </div>
        </div>
      </div>

<!-- Quinta fila -->
      <h5 class="mt-4"> <b> <i translate> MemoPayments.Additional Data </i> </b> </h5>
      <hr class="mb-5">

      <div class="p-fluid grid mt-3">
        <!-- Vat -->
        <div class="p-field col-6 col-md-4 col-lg-2 col-xl-2 pr-4">
          <div>
            <p-floatlabel>
              <input pInputText
                     #vat="ngModel"
                     maxlength="2"
                     name="vat"
                     type="text"
                     [(ngModel)]="payment.vat"
                     [disabled]="((!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || !isNewPayment || isTaskEditable || isArc || payment.paymentType == fare || payment.bsp == undefined"
                     [ngClass]="{ 'invalid-colors': vatTouched && (vat.errors?.pattern || vatError.description) }"
                     [pattern]="pattern.zeroToOnehundred"
                     (blur)="vatTouched = true">
              <label for="vat">VAT</label>
            </p-floatlabel>

            <small *ngIf="vatTouched && vat.errors?.pattern && !vatError.description" class="text-danger" translate> MemoPayments.Incorrect Vat Format </small>
            <small *ngIf="vatError.description" class="text-danger" translate> {{ vatError.description }} </small>
          </div>
        </div>
        <!-- RMIC -->
        <div class="p-field col-6 col-md-4 col-lg-2 col-xl-2 pr-4">
          <div>
            <p-floatlabel>
              <input pInputText
                     #rmic="ngModel"
                     name="rmic"
                     maxlength="5"
                     type="text"
                     [(ngModel)]="payment.rmic"
                     [disabled]="(!payment.frequency || !payment.memoContentOrigin || paymentSavedOk) || !isNewPayment || isTaskEditable || isArc"
                     [pattern]="pattern.DISH_alphanumeric">
              <label [ngClass]="{'control-label': !isNewPayment && !isTaskDetail && !isArc }" for="rmic"> RMIC </label>
            </p-floatlabel>

            <small *ngIf="rmic.errors?.pattern" class="text-danger" translate> Incorrect Alpha Numeric DISH Format </small>
            <small *ngIf="RMICError.description" class="text-danger" translate> {{ RMICError.description }} </small>
          </div>
        </div>
        <!-- Macro grupo -->
        <div class="p-field p-field-load col-6 col-md-4 col-lg-4 col-xl-4 pr-4">
          <div *ngIf="isNewPayment || isTaskEditable">
            <p-floatlabel>
              <p-select
                name="agentsMacroGroup"
                #agentsMacroGroup="ngModel"
                appendTo="body"
                optionLabel="name"
                [loading]="isLoadingMacroGroups"
                [filter]="true"
                [options]="agentsMacroGroupsList"
                [(ngModel)]="payment.agentsMacroGroup"
                [disabled]="(!isNewPayment && !isTaskEditable) || !payment.customer || !isAdmin || paymentSavedOk"
                [showClear]="true"
              />
              <label for="agentsMacroGroup" translate> Agent Macro Group </label>
            </p-floatlabel>
          </div>
          <!-- Macro grupo (deshabilitado) -->
          <div *ngIf="!isNewPayment && !isTaskEditable">
            <p-floatlabel>
              <input pInputText
                     name="agentsMacroGroup"
                     type="text"
                     [disabled]="true"
                     [ngModel]="payment.agentsMacroGroup?.name"
                     (ngModelChange)="payment.agentsMacroGroup.name=$event"/>
              <label for="agentsMacroGroup" translate> Agent Macro Group </label>
            </p-floatlabel>
          </div>
        </div>
        <!-- Razón de emisión -->
        <div class="p-field col-6 col-md-4 col-lg-4 col-xl-4 pr-4">
          <div>
            <p-floatlabel>
              <textarea pTextarea
                        #reasonForMemo="ngModel"
                        name="reasonForMemo"
                        maxlength="4455"
                        rows="2"
                        [(ngModel)]="payment.reasonForMemo"
                        [disabled]="(isNewPayment && (!payment.frequency || !payment.memoContentOrigin) || paymentSavedOk) || (!isNewPayment && !isTaskEditable)"
                        (blur)="reasonForMemoTouched = true"
                        (keydown.enter)="onEnter($event)">
              </textarea>
              <label [ngClass]="{'control-label': !isNewPayment && !isTaskDetail}" for="reasonForMemo" translate> MemoPayments.Reason For Memo </label>
            </p-floatlabel>

            <small *ngIf="reasonForMemoTouched && reasonForMemo.errors?.maxlength" class="text-danger" translate>
              {{ 'MemoPayments.Length Maximum ReasonMemo' | translate: {quantityMax: 4455} }}
            </small>
            <small *ngIf="reasonForMemoError.description" class="text-danger" translate>
              {{
                reasonForMemoError.description | translate:{
                  quantityMax: reasonForMemoError.quantityMax,
                  quantityMin: reasonForMemoError.quantityMin
                }
              }}
            </small>
          </div>
        </div>
      </div>

      <!-- Fila solo visible en el detalle de un pago único -->
      @if(!isNewPayment && !isTaskDetail){
          <div class="p-fluid grid">
            <!-- Servidor de subida (deshabilitado) -->
            <div *ngIf="!isPeriodicPayment" class="p-field col-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4 pr-4 mt-5">
              <p-floatlabel>
                <input pInputText
                       name="uploadRemote"
                       type="text"
                       [disabled]="true"
                       [ngModel]="payment.remoteUpload?.description"/>
                <label class="required" for="uploadRemote" translate> Upload To Remote </label>
              </p-floatlabel>
            </div>
            <!-- Fecha de emisión (deshabilitado) -->
            <div class="p-field col-6 col-md-4 col-lg-4 col-xl-4 col-xxl-1-5 pr-4 mt-5">
              <p-floatlabel>
                <input pInputText
                       name="issueDate"
                       type="text"
                       [disabled]="true"
                       [(ngModel)]="payment.sIssueDate"/>
                <label for="issueDate" translate> Issue Date </label>
              </p-floatlabel>
            </div>
            <!-- Fecha de creación (deshabilitado) -->
            <div class="p-field col-6 col-md-4 col-lg-4 col-xl-4 col-xxl-1-5 pr-4 mt-5">
              <p-floatlabel>
                <input pInputText
                       name="creationTime"
                       type="text"
                       [disabled]="true"
                       [(ngModel)]="payment.sCreationTime"/>
                <label for="creationTime" translate> Common.Creation Date </label>
              </p-floatlabel>
            </div>
            <!-- Hora de envío -->
            <div *ngIf="payment.sendTime" class="p-field col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-1-5 pr-4 mt-5">
              <p-floatlabel>
                <input pInputText
                       name="sendTime"
                       type="text"
                       [disabled]="true"
                       [(ngModel)]="payment.sSendTime"/>
                <label for="sendTime" translate>Send Time</label>
              </p-floatlabel>
            </div>
            <!-- Fecha de respuesta -->
            <div *ngIf="payment.responseTime && payment.ackFileName" class="p-field col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-1-5 pr-4 mt-5">
              <p-floatlabel>
                <input pInputText
                       name="responseTime"
                       type="text"
                       [disabled]="true"
                       [(ngModel)]="payment.sResponseTime"/>
                <label for="responseTime" translate> Response Date </label>
              </p-floatlabel>
            </div>
            <div *ngIf="payment.responseTime && payment.ackFileName" class="p-field col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-1-5 pr-4 mt-5">
              <p-floatlabel>
                <p-button
                  icon="pi pi-download"
                  label="{{ payment.ackFileName }}"
                  styleClass="p-button-link"
                  (onClick)="getFileToDownload(outputTypeFile)">
                </p-button>
                <label class="p-label-custom" translate> Response Bsplink </label>
              </p-floatlabel>
            </div>
          </div>
      }
      <!-- Fecha en fichero -->
      <div class="grid" *ngIf="!isNewPayment && !isTaskDetail">
        <div class="col p-text-right" translate>
          <h5 translate> Data In File </h5>
        </div>
      </div>
    </div>



    <div class="col-4">
      <!-- Estado -->
      <div *ngIf="!isNewPayment && !isTaskDetail">
        <div class="d-flex">
          <h5> <b> <i translate> Status </i> </b> </h5>
          <small class="ml-auto mr-5" [ngStyle]="{ 'color': getStatusColor(payment.memoStatus.memoStatusId)}">
            <b> {{ payment.memoStatus.status }} </b>
          </small>
        </div>
        <hr class="mr-4">
      </div>

      <div *ngIf="payment.frequency || isTaskDetail">
        <!-- Pago único -->
        <section *ngIf="payment.memoContentOrigin && isSinglePayment && !isPeriodicPayment && !isTaskDetail ">
          <app-payment-single-form
            [payment]="payment"
            [memoContentOriginSelected]="memoContentOriginSelected"
            [fileInput]="fileInput"
            [paymentSavedOk]="paymentSavedOk"
            (attachmentFileMethod)="attachmentFile($event)">
          </app-payment-single-form>
        </section>

        <!-- Pago periódico -->
        <section *ngIf="isPeriodicPayment || isTaskDetail">
          <app-payment-periodic-form
            [payment]="payment"
            [isNewPayment]="isNewPayment"
            [isTaskEditable]="isTaskEditable"
            [endTaskDateError]="endTaskDateError"
            [endTaskDateNotHigherThanStartDate]="endTaskDateNotHigherThanStartDate"
            [endTaskDateNotHigherThanToday]="endTaskDateNotHigherThanToday"
            [paymentSavedOk]="paymentSavedOk"
            (setEndTaskDateNotHigherThanStartDateMethod)="setEndTaskDateNotHigherThanStartDate()"
            (setEndTaskDateNotHigherThanTodayMethod)="setEndTaskDateNotHigherThanToday()"
          >
          </app-payment-periodic-form>
        </section>
      </div>

      <!-- Rango de períodos -->
      <div *ngIf="(isNewPayment && isPeriodRangePayment) || (!isNewPayment && payment.periodFrom != null)">
        <app-payment-period-range-form
          [payment]="payment"
          [memoContentOriginSelected]="memoContentOriginSelected"
          [paymentSavedOk]="paymentSavedOk"
          [isNewPayment]="isNewPayment"
          [isTaskEditable]="isTaskEditable"
          [isTaskDetail]="isTaskDetail"
        >
        </app-payment-period-range-form>
      </div>

      <!-- File Masstask or ARC -->
      <div *ngIf="!isNewPayment && !isTaskDetail" class="mb-3">
        <h5> <b> <i translate> File Masstask or ARC </i> </b> </h5>
        <hr class="mb-2 mr-4">
        <div class="p-field pt-2">
          <p-button link="true" severity="primary" icon="pi pi-download" label="{{ payment.fileName }}" (onClick)="getFileToDownload(inputTypeFile)"> </p-button>
        </div>
      </div>

<!-- Actions -->
    @if((!isPeriodicPayment || !isNewPayment) && !isTaskDetail){
      <h5> <b> <i translate> Actions </i> </b> </h5>
      <hr class="mb-2 mr-4">
    }
    <!-- Send Attachment -->
      <div class="p-fluid grid mt-2" *ngIf="isNewPayment || isTaskDetail">
        <div class="p-field col pr-1" *ngIf="!isTaskDetail">
          <div class="col gap-1 d-flex">
            <p-checkbox name="hasRelatedAttachments" [binary]="true" [(ngModel)]="payment.hasRelatedAttachments"
                        [disabled]="paymentSavedOk"> </p-checkbox>
            <label for="hasRelatedAttachments" class="ml-2 mt-1" translate>MemoPayments.Send Attachment</label>
          </div>
        </div>
      <!-- Auditoría de aerolínea -->
        <div class="p-field col pr-2">
          <div class="col gap-1 d-flex">
            <p-checkbox
              #airlineAuditory="ngModel"
              name="airlineAuditory"
              [(ngModel)]="payment.requestAirlineAudit"
              [binary]="true"
              [disabled]="!isTaskEditable && !isNewPayment || paymentSavedOk">
            </p-checkbox>
            <label for="airlineAuditory" class="ml-2 mt-1" translate> MemoPayments.Request Airline Auditory </label>
          </div>
        </div>
      </div>

      <!-- Send Attachment -->
      @if(isNewPayment || isTaskDetail){
        <div class="ml-2 mb-4">
          <h5 class="mt-4"> <b> <i translate> MemoPayments.Payment Sending </i> </b> </h5>
          <hr class="mb-2 mr-4">
          <div class="col d-inline-flex">
              @if(isLoadingRemotes){
                <p-progressBar mode="indeterminate"></p-progressBar>
              } @else {
                <p-inputSwitch name="isSFTPUploadable"
                               #isSFTPUploadable="ngModel"
                               class="mr-2"
                               [disabled]="(!isTaskEditable && !isNewPayment) || !enableRemotes || paymentSavedOk"
                               [(ngModel)]="payment.isSFTPUploadable"
                               (onChange)="isAllowToSetRemotes($event)"
                >
                </p-inputSwitch>
              <label for="isSFTPUploadable" translate> MemoPayments.Send To Remote </label>
              }
          </div>
          <!-- Servidor de subida -->
          @if(payment.isSFTPUploadable && (isNewPayment || isTaskEditable)){
            <div class="p-field p-field-load col-12 pr-12 mt-4">
              <p-floatlabel>
                <p-select
                  name="uploadRemote"
                  #uploadRemote="ngModel"
                  appendTo="body"
                  optionLabel="description"
                  [loading]="isLoadingRemotes"
                  [options]="uploadRemoteList"
                  [(ngModel)]="payment.remoteUpload"
                  [disabled]="!enableRemotes || paymentSavedOk"
                  [showClear]="true"
                  (onBlur)="uploadRemoteTouched = true"
                  [required]="payment.isSFTPUploadable"
                />
                <label class="required" for="uploadRemote" translate> Upload To Remote </label>
              </p-floatlabel>

              <small *ngIf="uploadRemoteTouched && uploadRemote.errors?.required" class="text-danger" translate>
                MemoPayments.Required Upload To Remote
              </small>
            </div>
          }
          <!-- Servidor de subida (deshabilitado)-->
          @if(payment.isSFTPUploadable && !isNewPayment && !isTaskEditable){
            <div class="p-field p-field-load col-12 pr-12 mt-4">
              <p-floatlabel>
                <input pInputText
                       name="uploadRemote"
                       type="text"
                       [disabled]="true"
                       [ngModel]="payment.remoteUpload?.description"/>
                <label class="required" for="uploadRemote" translate> Upload To Remote </label>
              </p-floatlabel>
            </div>
          }
          <!-- Servidor de bajada-->
          @if(payment.isSFTPUploadable && (isNewPayment || isTaskEditable)){
            <div class="p-field p-field-load col-12 pr-12 mt-4">
              <p-floatlabel>
                <p-select
                  name="remoteResponse"
                  #remoteResponse="ngModel"
                  appendTo="body"
                  optionLabel="description"
                  [filter]="true"
                  [loading]="isLoadingRemotes"
                  [options]="remoteResponseList"
                  [(ngModel)]="payment.remoteResponse"
                  [disabled]="!enableRemotes || isArc || paymentSavedOk"
                  [showClear]="true"
                />
                <label for="remoteResponse" translate> Remote For Responses </label>
              </p-floatlabel>
            </div>
          }
          <!-- Servidor de bajada (deshabilitado)-->
          @if(payment.isSFTPUploadable && !isNewPayment && !isTaskEditable){
            <div class="p-field p-field-load col-12 pr-12 mt-4">
              <p-floatlabel>
                  <input pInputText
                         name="remoteResponse"
                         type="text"
                         [disabled]="true"
                         [ngModel]="payment.remoteResponse?.description"
                         (ngModelChange)="payment.remoteResponse.description=$event"/>
                  <label for="remoteResponse" translate> Remote For Responses </label>
              </p-floatlabel>
            </div>
          }
        </div>
      }

    <!-- Actions -->
      @if(!isLoading && !isNewPayment && !isTaskEditable && !isTaskDetail){
        @if(isTaskDetail){
          <div class="ml-2">
            <h5> <b> <i translate> Actions </i> </b> </h5>
            <hr class="mr-4">
          </div>
        }
        <div class="d-flex flex-column gap-2 mb-4">
          @if(showMemosList){
            <p-button type="button" link="true" severity="primary" class="m-auto" label="{{ 'View Payment Detail' | translate }}" icon="pi pi-list" (click)="triggerShowHideMemosListAlert()"></p-button>
          } @else {
            <p-button type="button" link="true" severity="primary" class="m-auto" label="{{ 'MemoPayments.View Memos List' | translate }}" icon="pi pi-list" [disabled]="payment.xml === null" (click)="triggerShowHideMemosListAlert()"></p-button>
          }

          <p-button type="button" link="true" severity="primary" class="m-auto" label="{{ 'MemoPayments.Download Report' | translate }}" icon="pi pi-download" [disabled]="!payment.isExcel" (click)="getFileToDownload(excelTypeFile)"></p-button>

          @if(payment.parentId && isAdmin){
            <p-button type="button" link="true" severity="primary" class="m-auto" label="{{ 'See Task Detail' | translate }}" icon="pi pi-list" (click)="triggerViewTaskDetailAlert(payment)"></p-button>
          }
          @if(cancelEnable){
            <p-button type="button" link="true" severity="primary" class="m-auto" label="{{ 'MemoPayments.Cancel Payment' | translate }}" icon="pi pi-times-circle" (click)="triggerCancelPaymentAlert()"></p-button>
          }
          @if(reprocessableEnable){
            <p-button type="button" link="true" severity="primary" class="m-auto" label="{{ 'MemoPayments.Reprocess Payment' | translate }}" icon="pi pi-replay" (click)="triggerReprocessPaymentAlert()"></p-button>
          }
          @if(sendBspLinkEnable){
            <p-button type="button" link="true" severity="primary" class="m-auto" label="{{ 'MemoPayments.Send BspLink' | translate }}" icon="pi pi-send" (click)="triggerUpdateStatusAlert(sending)"></p-button>
          }
          @if(rejectFileEnable){
            <p-button type="button" link="true" severity="primary" class="m-auto" label="{{ 'MemoPayments.Reject Payment' | translate }}" icon="pi pi-minus-circle" (click)="triggerUpdateStatusAlert(cancelled)"></p-button>
          }
          @if(payment.memoStatus.memoStatusId == this.constants.memoStatusId.pendingAudit){
            <p-button type="button" link="true" severity="primary" class="m-auto" label="{{ 'MemoPayments.Exclude Documents' | translate }}" icon="pi pi-file-excel" (click)="triggerShowHideExcludeDocumentsAlert()"></p-button>
          }
        </div>

        @if(!isNewPayment && payment.xml === null){
          <small class="text-danger" translate> MemoPayments.Warning XML Not Created </small>
        }
        @if(!isNewPayment && !payment.isExcel){
          <small class="text-danger" translate> MemoPayments.Warning Report Not Created </small>
        }
      }

      <!-- Detalle -->
      <div *ngIf="payment.frequency || isTaskDetail">
        <section *ngIf="isDetail">
          <app-payment-management-detail>
          </app-payment-management-detail>
        </section>
      </div>
    </div>
  </div>
</form>

